import $ from 'jquery';
import { loadStripeJS } from './index';
import { onErrorShowMessage } from '~src/errors';
import Swal from 'sweetalert2';
import { refreshAiCredits } from '~core/payments';

/**
 * Helper function to show checkout modal (fallback flow)
 * @param {Object} checkoutSession - Checkout session from Stripe
 * @param {Object} selectedModule - Selected module info
 * @param {number} totalCredits - Total credits
 * @param {Object} options - Additional options
 * @param {Function} [options.onBack] - Callback when user clicks back button
 */
const showCheckoutModal = async (
  checkoutSession,
  selectedModule,
  totalCredits,
  options = {}
) => {
  try {
    await loadStripeJS();

    // Create and show Bootstrap modal with embedded checkout URL
    const modalHtml = `
        <div class="modal fade" id="checkoutModal" tabindex="-1" role="dialog" aria-labelledby="checkoutModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-xl" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="checkoutModalLabel">
                  Completa il tuo acquisto di: <span class="text-primary">${selectedModule.name}</span>
                </h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body p-0" style="height: 80vh;">
                <div id="checkout-container" style="height: 100%;"></div>
              </div>
              <div class="modal-footer justify-content-between">
                <button type="button" class="btn btn-outline-secondary" id="checkout-back-btn">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="mr-1" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z"/>
                  </svg>
                  Cambia metodo di pagamento
                </button>
                <button type="button" class="btn btn-link" data-dismiss="modal">Annulla</button>
              </div>
            </div>
          </div>
        </div>
      `;

    // Append modal to body
    const modalElement = document.createElement('div');
    modalElement.innerHTML = modalHtml;
    document.body.appendChild(modalElement);

    // Initialize and show the modal
    const $modal = $('#checkoutModal');

    // Close the loading SweetAlert before showing the modal
    Swal.close();

    $modal.modal({ backdrop: 'static', keyboard: false }, 'show');

    // Initialize Stripe embedded checkout
    const publishableKeys = {
      dev: 'pk_test_TvrUNX6ojFYWl6CdNOBfGmKw',
      prod: 'pk_live_l03AO8xqMuESwvU4CKFkWKRu',
    };
    const stripe = window.Stripe(publishableKeys[process.env.ENVIRONMENT]);

    const stripeOptions = {
      fetchClientSecret: () => {
        return checkoutSession.session.client_secret;
      },
      onComplete: async () => {
        $modal.modal('hide');
        await refreshAiCredits(totalCredits);
      },
    };

    const checkout = await stripe.initEmbeddedCheckout(stripeOptions);

    // Mount Checkout
    checkout.mount('#checkout-container');

    // Add custom CSS to make Stripe elements fill the container
    const styleElement = document.createElement('style');
    styleElement.textContent = `
        #checkout-container {
          display: flex;
          flex-direction: column;
        }
        
        #checkout-container iframe {
          flex: 1;
          min-height: 100%;
        }
      `;
    document.head.appendChild(styleElement);

    // Handle back button click
    let isGoingBack = false;
    $('#checkout-back-btn').on('click', function () {
      if (options.onBack) {
        isGoingBack = true;
        $modal.modal('hide');
      }
    });

    // Clean up modal and Stripe checkout when closed
    $modal.on('hidden.bs.modal', function () {
      checkout.destroy();
      $modal.remove();
      styleElement.remove(); // Remove the custom styles when modal is closed

      // Call onBack callback if user clicked back button
      if (isGoingBack && options.onBack) {
        options.onBack();
      }
    });
  } catch (error) {
    onErrorShowMessage(false, {
      icon: 'error',
      title: 'Errore',
      text: 'Si è verificato un errore durante il caricamento di Stripe.',
      confirmButtonColor: '#278e8e',
    });
    console.error('Stripe loading error:', error);
  }
};

export default showCheckoutModal;
